export const vipMegafonPath = '/vip-megafon/:subscriptionId'

export interface VipMegafonPathParams {
  subscriptionId: string
}
